import React, { useEffect, useRef } from 'react';
import { Box, IconButton, InputArea } from '@wix/design-system';
import { DismissSmall, SparklesFilledSmall } from '@wix/wix-ui-icons-common/lazy';
import { DomainSearchGateModule } from '../../module/domainSearchGate.module';
import s from './BngSearchFieldMobile.scss';
export const BngSearchFieldMobile = _ref => {
  let {
    value,
    onChange,
    onSubmit
  } = _ref;
  const {
    t
  } = DomainSearchGateModule.internals.useTranslations();
  const trimmedValue = value.trim();
  const inputRef = useRef(null);
  const onSubmitRef = useRef(onSubmit);
  onSubmitRef.current = onSubmit;
  const onClear = () => {
    var _inputRef$current;
    onChange('');
    (_inputRef$current = inputRef.current) == null || _inputRef$current.focus();
  };

  // On mobile, the multiline textarea's virtual keyboard "enter" key does not
  // reliably fire a keydown with key === 'Enter' (e.g. Android/GBoard reports
  // keyCode 229 during composition), so onKeyDown misses it and a newline is
  // inserted instead of submitting. `beforeinput` fires reliably across mobile
  // keyboards with inputType 'insertLineBreak' and is cancelable, so we use it
  // to submit the search. `enterkeyhint` surfaces a search action on the key.
  useEffect(() => {
    var _inputRef$current2;
    const el = (_inputRef$current2 = inputRef.current) == null ? void 0 : _inputRef$current2.textArea;
    if (!el) {
      return;
    }
    el.setAttribute('enterkeyhint', 'search');
    const handleBeforeInput = e => {
      if (e.inputType === 'insertLineBreak' || e.inputType === 'insertParagraph') {
        e.preventDefault();
        onSubmitRef.current();
      }
    };
    el.addEventListener('beforeinput', handleBeforeInput);
    return () => el.removeEventListener('beforeinput', handleBeforeInput);
  }, []);
  return /*#__PURE__*/React.createElement(Box, {
    className: s.row,
    verticalAlign: "top",
    width: "100%",
    padding: "14px 12px",
    boxSizing: "border-box",
    borderRadius: 12,
    overflow: "hidden",
    backgroundColor: "white"
  }, /*#__PURE__*/React.createElement(Box, {
    flex: 1,
    minWidth: 0
  }, /*#__PURE__*/React.createElement(InputArea, {
    ref: inputRef,
    className: s.input,
    value: value,
    onChange: e => onChange(e.target.value),
    placeholder: t('domains_search_gate.bng.mobile.gate_field.input.placeholder'),
    ariaLabel: t('domains_search_gate.bng.mobile.gate_field.input.placeholder'),
    autoGrow: true,
    minRowsAutoGrow: 1,
    maxRowsAutoGrow: 5,
    resizable: false
  })), /*#__PURE__*/React.createElement(Box, {
    className: s.actions,
    gap: "6px"
  }, trimmedValue && /*#__PURE__*/React.createElement(IconButton, {
    skin: "dark",
    priority: "tertiary",
    size: "small",
    "aria-label": t('domain_search_gate.bng_results.search_bar.clear_input'),
    onClick: onClear
  }, /*#__PURE__*/React.createElement(DismissSmall, null)), /*#__PURE__*/React.createElement(IconButton, {
    skin: "dark",
    priority: "primary",
    size: "small",
    "aria-label": t('domain_search_gate.bng_results.search_bar.generate_cta'),
    onClick: onSubmit
  }, /*#__PURE__*/React.createElement(SparklesFilledSmall, null))));
};
//# sourceMappingURL=BngSearchFieldMobile.js.map